import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject10() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      margin-left: 0;\n      margin-top: 15px;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      font-size: 18px;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    flex-direction: column;\n    align-items: center;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  ", "\n  .cancel {\n    font-size: 20px;\n    line-height: 1em;\n    margin-left: 40px;\n    color: ", ";\n    ", "\n    ", "\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 0;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    font-size: 18px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 20px;\n  line-height: 1em;\n  padding-bottom: 7px;\n  border-bottom: 2px solid ", ";\n  display: inline-flex;\n  align-items: flex-start;\n  cursor: pointer;\n  ", "\n  input {\n    display: none;\n  }\n  img {\n    display: block;\n    margin-left: 15px;\n    margin-top: 2px;\n    ", "\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 10px;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var TextField = styled.div(_templateObject());
TextField.displayName = "S.TextField";
export var Label = styled.label(_templateObject2(), function (props) {
  return props.theme.colors.red;
}, media.xxLargeScreen(_templateObject3()), media.xxLargeScreen(_templateObject4()));
export var InputWrapper = styled.div(_templateObject5(), media.mediumScreen(_templateObject6()), function (props) {
  return props.theme.colors.graySemi;
}, media.xxLargeScreen(_templateObject7()), media.mediumScreen(_templateObject8()));
export var HelpText = styled.span(_templateObject9(), function (props) {
  return props.theme.input.labelColor;
}, function (props) {
  return props.theme.input.labelFontSize;
});
export var ErrorMessages = styled.div(_templateObject10());